import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../core/services/authentication.service';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
    styleUrls: ['./notfound.component.css']
})
export class NotfoundComponent implements OnInit, OnDestroy {
    Title: string;
    Description: string;
    Padre: string;
    Hijo: string;

    isDocoutUser: boolean;

    private subscription;
    private subscription_change;

    constructor(private translateService: TranslateService,
        private authService: AuthenticationService) {


    }

    ngOnInit() {
        this.SetEnviroment();
        this.InitLanguage();
    }

    InitLanguage() {
        this.subscription =  this.translateService.get(['notfound'])
            .subscribe(values => {this.TranslateText(values); });

        this.subscription_change = this.translateService.onLangChange.subscribe(() => {
            this.translateService.get(['notfound'])
                .subscribe(values => {this.TranslateText(values); });
        });
    }
    TranslateText(values: any) {
        this.Title = values['notfound']['cabecera'];
        this.Description = values['notfound']['descripcion'];
        this.Hijo = values['notfound']['cabecera'];
    }

    SetEnviroment() {
        this.authService.isDocOutUser()
            .then((isDocUser: boolean) => {
                this.isDocoutUser = isDocUser;
            });

       this.authService.getClienteName$().subscribe(beadcrumbDad => {
            this.Padre  = beadcrumbDad;
       }).unsubscribe();
    }




    ngOnDestroy() {
        // console.log('Clear NOT FOUND');
        if (this.subscription != null) { this.subscription.unsubscribe(); }
        if (this.subscription_change != null) { this.subscription_change.unsubscribe(); }
        this.translateService = null;
        this.authService = null;
    }
}
